module.exports = __webpack_public_path__ + "img/189.85ad67e6.jpg";